<style lang="less" scoped>
    .editor-wrapper{
        max-width: 600px;
        margin: 0 auto;
    }
</style>
<template>
    <div>
        <Modal :title="edit_title"
               fullscreen
               v-model="config.modal"
               :loading="config.loading"
               @on-ok="editOk"
               ok-text="保存">
            <Spin v-if="loading" fix></Spin>
            <Form class="editor-wrapper"
                  ref="form"
                  :model="edit_recruit_need"
                  v-show="!loading"
                  :label-width="200">
                <FormItem label="填制时间">
                    <span>{{getFillTime(edit_recruit_need)}}</span>
                </FormItem>
                <FormItem label="编号">
                    <span v-if="edit_recruit_need.uid">{{edit_recruit_need.uid}}</span>
                    <span class="color-disabled" v-else>保存后自动生成</span>
                </FormItem>
                <FormItem label="填制人">
                    <span class="color-disabled">{{edit_recruit_need.fill_user}}</span>
                </FormItem>
                <FormItem label="岗位负责人" prop="apply_user" :rules="{ required: true, message: '申请人不能为空'}">
                    <CustomerSelector
                        v-model="edit_recruit_need.apply_user_id"
                        @on-change="setApplyUser"
                        width="400"
                        :disabled="!can_edit">
                        <span v-if="edit_recruit_need.apply_user">{{edit_recruit_need.apply_user}}</span>
                        <span class="color-grey" v-else>选择</span>
                    </CustomerSelector>
                </FormItem>
                <FormItem label="需求团队" prop="team_id" :rules="{type: 'number', required: true, min: 1, message: '请选择团队'}">
                    <Select v-model="edit_recruit_need.team_id" placeholder="请选择团队">
                        <Option v-for="team in teams" :value="team.id" :key="team.id" v-if="!team.del">{{ team.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="岗位选择" prop="recruit_job_id" :rules="{required: true, validator: validateJob}">
                    <Cascader :data="recruit_types_data" v-model="select_job" @on-change="jobChange"></Cascader>
                </FormItem>
                <FormItem label="岗位名称" prop="recruit_job_name" v-if="show_job_name_form" :rules="{required: true, message: '请填写岗位名称'}">
                    <i-input v-model="edit_recruit_need.recruit_job_name" placeholder="请填写..."></i-input>
                </FormItem>
                <FormItem label="工作地点" prop="office_id" :rules="{type: 'number', required: true, min: 1, message: '请选择工作地点'}">
                    <Select v-model="edit_recruit_need.office_id" placeholder="请选择工作地点">
                        <Option v-for="office in offices" :value="office.id" :key="office.id" v-if="!office.del">{{ office.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="需求人数" prop="need_count" :rules="{type: 'number', required: true, min: 1, message: '请填写需求人数'}">
                    <InputNumber v-model="edit_recruit_need.need_count" style="width: 100%"></InputNumber>
                </FormItem>
                <FormItem label="现有人数" prop="exist_count" :rules="{type: 'number', required: true, min: 0, message: '请填写现有人数'}">
                    <InputNumber v-model="edit_recruit_need.exist_count" style="width: 100%"></InputNumber>
                </FormItem>
                <FormItem label="薪资建议" prop="wage_start" :rules="{type: 'number', required: true, validator: validateWage}">
                    从 <InputNumber v-model="edit_recruit_need.wage_start" style="width: 100px"></InputNumber>
                    到 <InputNumber v-model="edit_recruit_need.wage_end" style="width: 100px"></InputNumber>
                    <span class="color-grey">例: 从 10000 到 20000</span>
                </FormItem>
                <FormItem label="期望到岗时间" prop="arrive_date">
                    <DatePicker type="date" :value="edit_recruit_need.arrive_date" @on-change="dateChange" placeholder="选择日期"></DatePicker>
                </FormItem>
                <FormItem label="申请原因" prop="recruit_reason" :rules="{required: true, message: '请选择申请原因'}">
                    <Select v-model="edit_recruit_need.recruit_reason" placeholder="请选择申请原因">
                        <Option v-for="reason in reasons" :value="reason.label" :label="reason.label" :key="reason.label">
                            <span>{{reason.label}}</span>
                            <span v-if="reason.remark">({{reason.remark}})</span>
                        </Option>
                    </Select>
                </FormItem>
                <FormItem label="详细原因" prop="recruit_reason_detail" :rules="{required: true, message: '请填写详细原因'}">
                    <i-input type="textarea" v-model="edit_recruit_need.recruit_reason_detail" :maxlength="800" placeholder="请填写..." :autosize="{minRows: 2,maxRows: 5}"></i-input>
                </FormItem>
                <FormItem label="岗位职责" prop="job_duty" :rules="{required: true, message: '请填写岗位职责'}">
                    <i-input type="textarea" v-model="edit_recruit_need.job_duty" :maxlength="250" placeholder="请填写..." :autosize="{minRows: 2,maxRows: 5}"></i-input>
                </FormItem>
                <FormItem label="岗位要求" prop="job_require" :rules="{required: true, message: '请填写岗位要求'}">
                    <i-input type="textarea" v-model="edit_recruit_need.job_require" :maxlength="1500" placeholder="请填写..." :autosize="{minRows: 2,maxRows: 10}"></i-input>
                </FormItem>
                <FormItem label="需要 HR 协助或讨论的信息" prop="remark">
                    <i-input type="textarea" v-model="edit_recruit_need.remark" :maxlength="500" placeholder="请填写..." :autosize="{minRows: 2,maxRows: 5}"></i-input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>
<script>
    import FlowUtil from '../../../libs/flow_util';
    import RecruitUtil from '../libs/util';
    import CustomerSelector from '../../components/customer/selector';
    import FileUploader from '../../components/file/uploader';
    import EditAttachments from '../../components/file/edit_attachments';
    import ViewerItem from '../../components/viewer/item';
    import {mapGetters} from "vuex";
    export default {
        components: { CustomerSelector, FileUploader, EditAttachments, ViewerItem },
        props: {
            //
        },
        data () {
            return {
                loading: false,
                config: {
                    modal: false,
                    loading: true
                },
                update_recruit_need_url: Util.api.update_recruit_need,
                edit_recruit_need: RecruitUtil.new_recruit_need,
                new_recruit_need: RecruitUtil.new_recruit_need,
                reasons: RecruitUtil.reasons,
                recruit_types: [],
                select_job: []
            }
        },
        computed: {
            cur_customer(){
                return this.$store.state.cur_customer;
            },
            ...mapGetters({
                teams: 'async/root_teams',
                teams_hash: 'async/root_teams_hash',
                offices: 'async/offices',
            }),
            recruit_types_data(){
                let data = [];
                this.recruit_types.forEach(type=>{
                    let type_data = {
                        value: type.id,
                        label: type.name,
                        children: []
                    };
                    type.recruit_jobs.forEach(job=>{
                        let job_data = {value: job.id, label: job.name};
                        type_data.children.push(job_data);
                    });
                    type_data.children.push({value: -1, label: '其他'});
                    data.push(type_data);
                });
                // data.push({value: -1, label: '其他'});
                return data;
            },
            edit_title(){
                return this.edit_recruit_need.id ? `编辑招聘需求` : `添加招聘需求`;
            },
            can_edit(){
                return FlowUtil.inEditNode(this.edit_recruit_need);
            },
            show_job_name_form(){
                return this.edit_recruit_need.recruit_type_id === -1 || this.edit_recruit_need.recruit_job_id === -1;
            }
        },
        watch: {
            cur_customer(){
                this.setFillUser(this.cur_customer);
                this.setApplyUser(this.cur_customer);
                this.edit_recruit_need.team_id = this.cur_customer.root_team_id;
            },
        },
        created(){
            this.edit_recruit_need = Util.clone(this.new_recruit_need);
            this.init();
        },
        mounted(){
            //
        },
        methods: {
            init(){
                if(this.cur_customer && this.cur_customer.id){
                    this.edit_recruit_need.team_id = this.cur_customer.root_team_id;
                    this.setFillUser(this.cur_customer);
                    this.setApplyUser(this.cur_customer);
                }
                this.getRecruitTypes();
            },
            edit(recruit_need){
                this.config.modal = true;
                this.$refs.form.resetFields();
                if(recruit_need){
                    if(recruit_need.id){
                        // 编辑
                        this.loading = true;
                        RecruitUtil.getDetail(recruit_need.id).then((data)=>{
                            let rn = data.recruit_need;
                            rn.wage_start = rn.wage_start * 1;
                            rn.wage_end = rn.wage_end * 1;
                            this.$set(this, 'edit_recruit_need', rn);
                            this.setSelectJob();
                        }).catch((e)=>{
                            this.$Message.error('获取数据失败, 请重试!');
                            this.config.modal = false;
                        }).finally(()=>{
                            this.loading = false;
                        });
                    }else{
                        // 复制
                        this.$set(this, 'edit_recruit_need', Util.clone(recruit_need));
                        this.init();
                        this.setSelectJob();
                    }
                }else{
                    // 添加
                    this.$set(this, 'edit_recruit_need', Util.clone(this.new_recruit_need));
                    this.init();
                }
            },
            validateWage(rule, value, callback){
                if(this.edit_recruit_need.wage_start <= 0){
                    callback(new Error('最低薪资必须大于0'));
                }else if(this.edit_recruit_need.wage_end <= 0){
                    callback(new Error('最高薪资必须大于0'));
                }else if(this.edit_recruit_need.wage_start > this.edit_recruit_need.wage_end){
                    callback(new Error('最低薪资不能大于最高薪资'));
                }else{
                    callback();
                }
            },
            validateJob(rule, value, callback){
                if(this.edit_recruit_need.recruit_type_id === 0){
                    callback(new Error('请选择岗位'));
                }else{
                    callback();
                }
            },
            validateField(prop, callback){
                this.$refs.form.validateField(prop, callback);
            },
            formatPrice(price){
                return Util.formatPrice(price);
            },
            jobChange(value, selected_data){
                let type_id = value[0];
                let job_id = value[1];
                this.edit_recruit_need.recruit_type_id = type_id;
                this.edit_recruit_need.recruit_job_id = job_id ? job_id : 0;
                if(type_id === -1 || job_id === -1){
                    this.edit_recruit_need.recruit_job_name = '';
                }else if(selected_data[1]){
                    this.edit_recruit_need.recruit_job_name = selected_data[1].label;
                }
            },
            dateChange(date){
                this.edit_recruit_need.arrive_date = date;
            },
            autoCheckValid(){
                if(this.$refs.form){
                    this.$refs.form.validate();
                }
            },
            editOk(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        Util.ajax.post(this.update_recruit_need_url, this.edit_recruit_need).then((response)=>{
                            return response.data;
                        }).then((res)=>{
                            if(res.code === 1){
                                let recruit_need = res.data.recruit_need;
                                this.$emit('update', recruit_need);
                                this.config.modal = false;
                                this.$Message.success('保存成功!');
                            }else{
                                this.$Modal.error({title: '提示',content: res.msg});
                            }
                        }).catch((e)=>{
                            this.$Modal.error({title: '提示',content: e.message});
                        }).finally(()=>{
                            this.resetEditLoading();
                        });
                    } else {
                        this.$Message.error('表单有误, 请检查!');
                        this.resetEditLoading();
                    }
                })
            },
            resetEditLoading(){
                this.config.loading = false;
                setTimeout(()=>{
                    this.config.loading = true;
                }, 500);
            },
            getRecruitTypes(){
                Util.ajax.get(Util.api.get_all_recruit_types).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    if(res.code === 1){
                        this.recruit_types = res.data.recruit_types;
                    }else{
                        this.$Modal.error({title: '提示',content: res.msg});
                    }
                }).catch((e)=>{
                    this.$Modal.error({title: '提示',content: e.message});
                });
            },
            getFillTime(edit_recruit_need){
                let time = edit_recruit_need.created_at || new Date();
                return moment(time).format('YYYY-MM-DD');
            },
            setFillUser(customer){
                this.edit_recruit_need.fill_user_id = customer.id;
                this.edit_recruit_need.fill_user = customer.account;
            },
            setApplyUser(customer){
                this.edit_recruit_need.apply_user_id = customer.id;
                this.edit_recruit_need.apply_user = customer.account;
            },
            setSelectJob(){
                this.select_job = [];
                this.select_job[0] = this.edit_recruit_need.recruit_type_id;
                this.select_job[1] = this.edit_recruit_need.recruit_job_id;
            }
        }
    }
</script>
